import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteComputerPermissions extends BaseScenesPermissions {}

export default MultiquoteComputerPermissions
